export function formatResultCountRange(count) {
    const num = Number(count || 0);

    if (num === 0) return "0";
    if (num <= 100) return "～100";
    if (num <= 500) return "101～500";
    if (num <= 1000) return "501～1000";
    if (num <= 5000) return "1001～5000";
    if (num <= 10000) return "5001～10000";
    if (num <= 50000) return "10001～50000";

    const start = Math.floor((num - 1) / 50000) * 50000 + 1;
    const end = Math.ceil(num / 50000) * 50000;
    return `${start}～${end}`;
}